const moment = require('moment')

APP.FilterActivities = function ($) {

    "use strict";
    var startDate, endDate, selectedActivityType = undefined;
    var dateRangePicker = $('#daterange');
    //var activityTypeMenu = $('#activity-type');
    var activityTypeMenu = $('#activity-type a');
    var activities = $('.activity-line-action-list');
    // The <ul class="pagination">
    var pager = $('.ajax-pager');

    // Should be the <tbody id="ajax">
    var container = $('#ajax');
    var daysHolder = 'article';
    var url = '';

    var options = {
        //"timePicker": true,
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        "linkedCalendars": false,
        "autoUpdateInput": false,
        "alwaysShowCalendars": true,
        "showWeekNumbers": false,
        "showDropdowns": true,
        "showISOWeekNumbers": false
    };

    var initialize = function () {
        dateRangePicker.daterangepicker(options);
        dateRangePickerHandler();
        activityMenuHandler();
        popStateListener();
        pageChangeListener();
    };

    var dateRangePickerHandler = function () {
        dateRangePicker.on('apply.daterangepicker', function (ev, picker) {
            var s = picker.startDate.startOf('day');
            var e = picker.endDate.endOf('day');
            startDate = s.format('YYYY-MM-DD');
            endDate = e.format('YYYY-MM-DD');
            dateRangePicker.val(startDate + ' - ' + endDate);

            // filterActivities();
        });

    };

    var activityMenuHandler = function () {
        /*activityTypeMenu.on('change', function () {
            filterActivities();
        });*/

        activityTypeMenu.on('click', function (e) {
            e.preventDefault();
            $('#activity-type').find('.list-group-item').removeClass('active');
            $(this).closest('.list-group-item').addClass('active');
            filterActivities($(this));
        });
    };

    // Listen for history change
    var popStateListener = function () {
        $(window).bind('popstate', function (e) {
            // if the foward / slash buttons are clicked, reload the last page
            load(window.location.href, false);
        });
    };

    var filterActivities = function (element) {
        if(element) {
            selectedActivityType = element.data('value') == 'all' ? undefined : element.data('value');
        }

        // load data
        load(rebuildURI(), true);
    };

    var rebuildURI = function () {
        // rebuilt the url to get the proper results.
        var url = new URL(window.location);

        // get all current url parameters as Object
        var params = url.searchParams;

        // if we just order the data, we use the ?page variable else reset to page 1
        params.set('page', 1);
         // if the search field is empty set to undefined. The plugin will remove the parameter automaticaly
         var dates = startDate ? startDate + ' - ' + endDate : undefined;
        params.set('dates', dates);
        // if the order params has been set, use it else use the one in the url
        // params.set('activity', selectedActivityType);

        params = '?' + params.toString();

        return params;

    };


    // When the user change the page using the paginator bar
    var pageChangeListener = function () {
        $(document).on('click', '.pagination a', function (e) {
            load($(this).attr('href'), true);
            e.preventDefault();
        });
    };

    // load data
    var load = function (url, push) {
        $.when(callAPI(url)).then(function (data) {
            updatePage(data);
            if (push) {
                history.pushState(null, '', url);
            }
        }).fail(function () {
            alert('Data could not be loaded.');
        });
    };

    var callAPI = function (url) {
        return $.ajax({url: url, type: 'GET', dataType: 'json'});
    };

    var updatePage = function (data) {

        container.html(data.html);
        pager.html(data.pager);

        $('.pager-currentpage').text(data.currentpage);
        $('.pager-lastpage').text(data.lastpage);
        $('.pager-total').text(data.total);
    };

    return {
        init: function () {
            initialize();
        }
    }
}(jQuery);

$(document).ready(function () {
    APP.FilterActivities.init();

    //var sortableSelect = $('select.sort-alpha');
    //sortableSelect.sortAlphabetically();
    //sortableSelect.selectpicker('refresh');
});

// Sort options alphabetically
// <select class="sort-alpha" data-selected="value" ...
$.fn.sortAlphabetically = function () {
    var first = $('option', this).eq(0).clone();
    var selected = this.data('selected') || 'all';
    $('option', this).eq(0).remove();
    this.append($('option', this).remove().sort(function (a, b) {
        var at = $(a).text(), bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
    })).prepend(first).find('option[value="' + selected + '"]').prop('selected', true);
};
